import editQualities from "./EditQualities";

export const ownMods = (mods) => [].concat(mods || []).filter((m) => m && !m.ToIntegrated)

const applyAttachmentMods = (item, attachI, mods, remove, fromAttachment) => {
    const list = [].concat(mods || [])
    let newItem = editQualities(item, ownMods(list), remove, fromAttachment)
    const integrated = list.filter((m) => m?.ToIntegrated)
    const attachment = newItem.Attachments?.[attachI]
    if (integrated.length && Array.isArray(attachment?.WeaponModifiers)) {
        newItem.Attachments[attachI] = {
            ...attachment,
            WeaponModifiers: attachment.WeaponModifiers.map((w) => editQualities(w, integrated, remove, fromAttachment)),
        }
    }
    return newItem
}

export default applyAttachmentMods
